import React, { PureComponent } from 'react';
import classNames from 'classnames';
import NavMenu from '../nav-menu';

const Header = (props) => {
  const { logo, className, siteUrl } = props;
  const logoClasses = classNames('header-logo', logo.className);

  const headerClasses = classNames('header', className);
  return <header className={headerClasses}>
    <a href={siteUrl || '/patient-solutions/providers'} className='header-logo-container'>
      <div role='img' aria-label={logo.ariaLabel} className={logoClasses}></div>
    </a>
    { props.children }
  </header>;
};

class NavigationHeader extends PureComponent {
  state = {
    showMenu: null
  }

  toggleMenu = () => {
    const { showMenu: previousState } = this.state;
    this.setState({ showMenu: !previousState });
  }

  render() {
    const { showMenu } = this.state;

    const headerClasses = classNames('header', {
      'header--show': showMenu,
      'header--close': showMenu === false
    });

    const links = [ { className: 'nav-back', title: 'Close', action: this.toggleMenu }, ...this.props.navlinks ];
    return <Header {...this.props} className={headerClasses}>
      { this.props.helpfulMsg }
      <NavMenu toggleMenu={this.toggleMenu} links={links} showMenu={showMenu} />
    </Header>;
  }
}

NavigationHeader.defaultProps = {
  logo: {},
  navlinks: []
};

Header.defaultProps = {
  logo: {}
};

export default Header;
export {
  NavigationHeader
};

